var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"verify-client"},[_c('Pending',{attrs:{"state":_vm.verifySuccess,"message":'Confirming Verification'},on:{"exit":_vm.exitVerify}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }